// import React, { useCallback, useEffect, useState } from 'react';
// import axios from 'axios';
// import { BASE_URL } from "../../../config";
// import { isAuthenticated, AuthRequired } from './payment';

// // ---------------------------------------------------------------------------
// // WELFARE MODULE (self-contained)
// // Engineer submits withdrawal requests and views own balance/history.
// // Admin / SuperEngineer reviews requests and views all engineer balances.
// // Usage:  <Welfare currentUser={{ id, name, role, token }} />
// // ---------------------------------------------------------------------------

// const api = axios.create({
//   baseURL: BASE_URL,
// });

// // FIX: token was never attached — see the identical note in Advancepayment.jsx.
// api.interceptors.request.use((config) => {
//   try {
//     const stored = JSON.parse(localStorage.getItem('NagpurProperties') || '{}');
//     if (stored?.token) config.headers.Authorization = `Bearer ${stored.token}`;
//   } catch {
//     // no stored session — request goes out unauthenticated, backend will 401
//   }
//   return config;
// });

// const REASON_TYPES = ['MEDICAL_EMERGENCY', 'FAMILY_EMERGENCY', 'EDUCATION', 'TRAVEL', 'OTHER'];
// const WELFARE_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'];

// // FIX: normalize role comparison — see the identical note in Advancepayment.jsx.
// const REVIEWER_ROLE_VARIANTS = ['ADMIN', 'SUPERENGINEER', 'SUPER_ENGINEER', 'SUPER ENGINEER'];
// function isReviewerRole(role) {
//   return REVIEWER_ROLE_VARIANTS.includes(String(role || '').toUpperCase());
// }

// const submitWelfareWithdrawal = (payload) =>
//   api.post('/welfare/money-withdrwal/request', payload).then((r) => r.data);

// const reviewWelfareWithdrawal = (welfareRequestId, reviewerId, reviewerRole, status, remark) =>
//   api
//     .put(`/welfare/money-withdrwal/request/${welfareRequestId}/review`, null, {
//       params: { reviewerId, reviewerRole, status, remark },
//     })
//     .then((r) => r.data);

// const getAllWelfareRequests = (params) =>
//   api.get('/welfare/money-withdrwal/requests', { params }).then((r) => r.data);

// const getEngineerWelfareRequests = (engineerId) =>
//   api.get(`/welfare/engineer/${engineerId}/money-withdrwal/request`).then((r) => r.data);

// const getEngineerWelfareSummary = (engineerId) =>
//   api.get(`/welfare/engineer/${engineerId}/summary`).then((r) => r.data);

// const getAllEngineersWelfareSummary = () =>
//   api.get('/welfare/all-engineer/summary').then((r) => r.data);

// // ---------------------------------------------------------------------------
// // UI: Withdrawal form (Engineer)
// // ---------------------------------------------------------------------------
// function WithdrawRequestForm({ onSubmitted }) {
//   const [form, setForm] = useState({ amount: '', withdrawalReason: REASON_TYPES[0], remarks: '' });
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState(null);

//   const handleChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!form.amount || Number(form.amount) <= 0) {
//       setError('Enter a valid amount.');
//       return;
//     }
//     setSubmitting(true);
//     setError(null);
//     try {
//       await submitWelfareWithdrawal({ ...form, amount: Number(form.amount) });
//       setForm({ amount: '', withdrawalReason: REASON_TYPES[0], remarks: '' });
//       onSubmitted?.();
//     } catch (err) {
//       setError(err?.response?.data?.message || err.message);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} style={styles.form}>
//       <h3>Request Welfare Withdrawal</h3>
//       <label style={styles.label}>
//         Amount
//         <input type="number" name="amount" min="1" value={form.amount} onChange={handleChange} style={styles.input} required />
//       </label>
//       <label style={styles.label}>
//         Reason
//         <select name="withdrawalReason" value={form.withdrawalReason} onChange={handleChange} style={styles.input}>
//           {REASON_TYPES.map((r) => <option key={r} value={r}>{r.replace(/_/g, ' ')}</option>)}
//         </select>
//       </label>
//       <label style={styles.label}>
//         Remarks
//         <textarea name="remarks" value={form.remarks} onChange={handleChange} rows={2} style={styles.input} />
//       </label>
//       {error && <p style={styles.error}>{error}</p>}
//       <button type="submit" disabled={submitting} style={styles.btnPrimary}>
//         {submitting ? 'Submitting...' : 'Submit Request'}
//       </button>
//     </form>
//   );
// }

// // ---------------------------------------------------------------------------
// // UI: Review modal (Admin / SuperEngineer)
// // ---------------------------------------------------------------------------
// function WelfareReviewModal({ request, currentUser, onClose, onReviewed }) {
//   const [status, setStatus] = useState('APPROVED');
//   const [remark, setRemark] = useState('');
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState(null);

//   const handleSave = async () => {
//     setSaving(true);
//     setError(null);
//     try {
//       await reviewWelfareWithdrawal(request.id, currentUser.id, currentUser.role, status, remark);
//       onReviewed?.();
//       onClose();
//     } catch (err) {
//       setError(err?.response?.data?.message || err.message);
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <div style={styles.overlay} onClick={onClose}>
//       <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
//         <h3>Review Welfare #{request.id}</h3>
//         <p style={styles.subtitle}>{request.engineerName} · ₹{request.requestedAmount}</p>

//         <label style={styles.label}>
//           Decision
//           <select value={status} onChange={(e) => setStatus(e.target.value)} style={styles.input}>
//             <option value="APPROVED">APPROVED</option>
//             <option value="REJECTED">REJECTED</option>
//           </select>
//         </label>
//         <label style={styles.label}>
//           Remark
//           <textarea value={remark} onChange={(e) => setRemark(e.target.value)} rows={2} style={styles.input} />
//         </label>

//         {error && <p style={styles.error}>{error}</p>}

//         <div style={styles.modalActions}>
//           <button onClick={onClose} disabled={saving} style={styles.btnSecondary}>Cancel</button>
//           <button onClick={handleSave} disabled={saving} style={styles.btnPrimary}>
//             {saving ? 'Saving...' : 'Confirm'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // UI: Summary card
// // ---------------------------------------------------------------------------
// function SummaryCard({ summary }) {
//   if (!summary) return null;
//   return (
//     <div style={styles.summaryCard}>
//       <div><span style={styles.summaryLabel}>Balance</span><br /><span style={styles.summaryValue}>₹{summary.currentBalance}</span></div>
//       <div><span style={styles.summaryLabel}>Total Credits</span><br /><span style={{ ...styles.summaryValue, color: '#1e8e5a' }}>₹{summary.totalCredits}</span></div>
//       <div><span style={styles.summaryLabel}>Total Withdrawals</span><br /><span style={{ ...styles.summaryValue, color: '#c0392b' }}>₹{summary.totalWithdrawals}</span></div>
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // Engineer view: summary + form + own history
// // ---------------------------------------------------------------------------
// function EngineerWelfareView({ currentUser }) {
//   const [summary, setSummary] = useState(null);
//   const [items, setItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const load = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const [s, r] = await Promise.all([
//         getEngineerWelfareSummary(currentUser.id),
//         getEngineerWelfareRequests(currentUser.id),
//       ]);
//       setSummary(s);
//       setItems(Array.isArray(r) ? r : []);
//     } catch (err) {
//       setError(err?.response?.data?.message || err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [currentUser.id]);

//   useEffect(() => { load(); }, [load]);

//   return (
//     <div>
//       <SummaryCard summary={summary} />
//       <WithdrawRequestForm onSubmitted={load} />
//       <h3>My Welfare Request History</h3>
//       {loading && <p style={styles.muted}>Loading...</p>}
//       {error && <p style={styles.error}>{error}</p>}
//       {!loading && !error && !items.length && <p style={styles.muted}>No welfare requests found.</p>}
//       {!loading && !error && items.length > 0 && (
//         <table style={styles.table}>
//           <thead>
//             <tr>
//               <th style={styles.th}>ID</th>
//               <th style={styles.th}>Amount</th>
//               <th style={styles.th}>Reason</th>
//               <th style={styles.th}>Status</th>
//               <th style={styles.th}>Requested</th>
//             </tr>
//           </thead>
//           <tbody>
//             {items.map((row) => (
//               <tr key={row.id}>
//                 <td style={styles.td}>{row.id}</td>
//                 <td style={styles.td}>₹{row.requestedAmount}</td>
//                 <td style={styles.td}>{row.withdrawalReason?.replace(/_/g, ' ')}</td>
//                 <td style={styles.td}>{row.status}</td>
//                 <td style={styles.td}>{row.requestDate}</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // Reviewer view: requests tab + all-balances tab
// // ---------------------------------------------------------------------------
// function ReviewerWelfareView({ currentUser }) {
//   const [tab, setTab] = useState('requests');
//   const [filters, setFilters] = useState({});
//   const [page, setPage] = useState(0);
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selected, setSelected] = useState(null);
//   const [balances, setBalances] = useState([]);
//   const [balancesLoading, setBalancesLoading] = useState(false);
//   const filterKey = JSON.stringify(filters);

//   const loadRequests = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const result = await getAllWelfareRequests({ ...filters, page, size: 10 });
//       setData(result);
//     } catch (err) {
//       setError(err?.response?.data?.message || err.message);
//     } finally {
//       setLoading(false);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [filterKey, page]);

//   const loadBalances = useCallback(async () => {
//     setBalancesLoading(true);
//     try {
//       const result = await getAllEngineersWelfareSummary();
//       setBalances(Array.isArray(result) ? result : []);
//     } catch (err) {
//       setError(err?.response?.data?.message || err.message);
//     } finally {
//       setBalancesLoading(false);
//     }
//   }, []);

//   useEffect(() => { if (tab === 'requests') loadRequests(); }, [tab, loadRequests]);
//   useEffect(() => { if (tab === 'balances') loadBalances(); }, [tab, loadBalances]);
//   useEffect(() => { setPage(0); }, [filterKey]);

//   return (
//     <div>
//       <div style={styles.tabRow}>
//         <button style={tab === 'requests' ? styles.tabActive : styles.tab} onClick={() => setTab('requests')}>Requests</button>
//         <button style={tab === 'balances' ? styles.tabActive : styles.tab} onClick={() => setTab('balances')}>All Balances</button>
//       </div>

//       {tab === 'requests' && (
//         <>
//           <div style={styles.filterRow}>
//             <input placeholder="Engineer ID" style={styles.input}
//               onChange={(e) => setFilters((f) => ({ ...f, engineerId: e.target.value || undefined }))} />
//             <select style={styles.input} defaultValue=""
//               onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value || undefined }))}>
//               <option value="">All statuses</option>
//               {WELFARE_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
//             </select>
//             <input type="date" style={styles.input}
//               onChange={(e) => setFilters((f) => ({ ...f, fromDate: e.target.value || undefined }))} />
//             <input type="date" style={styles.input}
//               onChange={(e) => setFilters((f) => ({ ...f, toDate: e.target.value || undefined }))} />
//           </div>

//           {loading && <p style={styles.muted}>Loading...</p>}
//           {error && <p style={styles.error}>{error}</p>}
//           {!loading && !error && !(data?.content || []).length && <p style={styles.muted}>No welfare requests found.</p>}
//           {!loading && !error && (data?.content || []).length > 0 && (
//             <table style={styles.table}>
//               <thead>
//                 <tr>
//                   <th style={styles.th}>ID</th>
//                   <th style={styles.th}>Engineer</th>
//                   <th style={styles.th}>Amount</th>
//                   <th style={styles.th}>Status</th>
//                   <th style={styles.th}>Requested</th>
//                   <th style={styles.th}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {data.content.map((row) => (
//                   <tr key={row.id}>
//                     <td style={styles.td}>{row.id}</td>
//                     <td style={styles.td}>{row.engineerName}</td>
//                     <td style={styles.td}>₹{row.requestedAmount}</td>
//                     <td style={styles.td}>{row.status}</td>
//                     <td style={styles.td}>{row.requestDate}</td>
//                     <td style={styles.td}>
//                       {row.status === 'PENDING' && (
//                         <button style={styles.linkBtn} onClick={() => setSelected(row)}>Review</button>
//                       )}
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}

//           {data && data.totalPages > 1 && (
//             <div style={styles.pagination}>
//               <button disabled={!data.hasPrevious} onClick={() => setPage((p) => p - 1)} style={styles.btnSecondary}>Prev</button>
//               <span style={styles.muted}>Page {data.currentPage + 1} of {data.totalPages}</span>
//               <button disabled={!data.hasNext} onClick={() => setPage((p) => p + 1)} style={styles.btnSecondary}>Next</button>
//             </div>
//           )}
//         </>
//       )}

//       {tab === 'balances' && (
//         <>
//           {balancesLoading && <p style={styles.muted}>Loading...</p>}
//           {!balancesLoading && !balances.length && <p style={styles.muted}>No engineers found.</p>}
//           {!balancesLoading && balances.length > 0 && (
//             <table style={styles.table}>
//               <thead>
//                 <tr>
//                   <th style={styles.th}>Engineer</th>
//                   <th style={styles.th}>Balance</th>
//                   <th style={styles.th}>Total Credits</th>
//                   <th style={styles.th}>Total Withdrawals</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {balances.map((row) => (
//                   <tr key={row.engineerId}>
//                     <td style={styles.td}>{row.engineerName}</td>
//                     <td style={styles.td}>₹{row.currentBalance}</td>
//                     <td style={styles.td}>₹{row.totalCredits}</td>
//                     <td style={styles.td}>₹{row.totalWithdrawals}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </>
//       )}

//       {selected && (
//         <WelfareReviewModal
//           request={selected}
//           currentUser={currentUser}
//           onClose={() => setSelected(null)}
//           onReviewed={loadRequests}
//         />
//       )}
//     </div>
//   );
// }

// // ---------------------------------------------------------------------------
// // Root export
// // ---------------------------------------------------------------------------
// export default function Welfare({ currentUser }) {
//   if (!isAuthenticated(currentUser)) return <AuthRequired />;
//   const isReviewer = isReviewerRole(currentUser?.role);
//   return isReviewer ? <ReviewerWelfareView currentUser={currentUser} /> : <EngineerWelfareView currentUser={currentUser} />;
// }
// const styles = {
//   form: { maxWidth: 420, display: 'flex', flexDirection: 'column', gap: 12, background: '#fff', padding: 20, borderRadius: 10, border: '1px solid #eee', marginBottom: 24 },
//   label: { display: 'flex', flexDirection: 'column', gap: 4, fontSize: 13, fontWeight: 600, color: '#444' },
//   input: { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, fontWeight: 400 },
//   btnPrimary: { padding: '8px 16px', border: 'none', borderRadius: 6, background: '#2d5bd7', color: '#fff', fontWeight: 600, cursor: 'pointer' },
//   btnSecondary: { padding: '8px 16px', border: '1px solid #ddd', borderRadius: 6, background: '#fff', color: '#333', fontWeight: 600, cursor: 'pointer' },
//   linkBtn: { background: 'none', border: 'none', color: '#2d5bd7', fontWeight: 600, cursor: 'pointer', padding: 0, fontSize: 13 },
//   error: { color: '#c0392b', fontSize: 13 },
//   muted: { color: '#777', fontSize: 13 },
//   table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, overflow: 'hidden' },
//   th: { padding: '10px 12px', textAlign: 'left', borderBottom: '1px solid #f0f0f0', background: '#fafafa', fontSize: 13, fontWeight: 600, color: '#555' },
//   td: { padding: '10px 12px', textAlign: 'left', borderBottom: '1px solid #f0f0f0', fontSize: 13 },
//   overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
//   modal: { background: '#fff', width: 420, maxWidth: '92vw', borderRadius: 10, padding: 24, display: 'flex', flexDirection: 'column', gap: 12, maxHeight: '90vh', overflowY: 'auto' },
//   subtitle: { color: '#777', fontSize: 13, margin: '-8px 0 4px' },
//   modalActions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 },
//   tabRow: { display: 'flex', gap: 8, marginBottom: 16 },
//   tab: { padding: '8px 16px', border: '1px solid #ddd', background: '#fff', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#555' },
//   tabActive: { padding: '8px 16px', border: '1px solid #2d5bd7', background: '#2d5bd7', color: '#fff', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
//   filterRow: { display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' },
//   pagination: { display: 'flex', alignItems: 'center', gap: 10, padding: '12px 4px' },
//   summaryCard: { display: 'flex', gap: 24, background: '#fff', border: '1px solid #eee', borderRadius: 10, padding: '18px 24px', marginBottom: 20 },
//   summaryLabel: { fontSize: 12, color: '#888' },
//   summaryValue: { fontSize: 20, fontWeight: 700, color: '#222' },
// };

















import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL } from "../../../config";
import { isAuthenticated, AuthRequired } from './payment';

// ---------------------------------------------------------------------------
// WELFARE MODULE (self-contained)
// Engineer submits withdrawal requests and views own balance/history.
// Admin / SuperEngineer reviews requests and views all engineer balances.
// Usage:  <Welfare currentUser={{ id, name, role, token }} />
// ---------------------------------------------------------------------------

const api = axios.create({
  baseURL: BASE_URL,
});

// FIX: token was never attached — see the identical note in Advancepayment.jsx.
api.interceptors.request.use((config) => {
  try {
    const stored = JSON.parse(localStorage.getItem('NagpurProperties') || '{}');
    if (stored?.token) config.headers.Authorization = `Bearer ${stored.token}`;
  } catch {
    // no stored session — request goes out unauthenticated, backend will 401
  }
  return config;
});

const REASON_TYPES = ['MEDICAL_EMERGENCY', 'FAMILY_EMERGENCY', 'EDUCATION', 'TRAVEL', 'OTHER'];
const WELFARE_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'];

// FIX: normalize role comparison — see the identical note in Advancepayment.jsx.
const REVIEWER_ROLE_VARIANTS = ['ADMIN', 'SUPERENGINEER', 'SUPER_ENGINEER', 'SUPER ENGINEER'];
function isReviewerRole(role) {
  return REVIEWER_ROLE_VARIANTS.includes(String(role || '').toUpperCase());
}

const submitWelfareWithdrawal = (payload) =>
  api.post('/welfare/money-withdrwal/request', payload).then((r) => r.data);

const reviewWelfareWithdrawal = (welfareRequestId, reviewerId, reviewerRole, status, remark) =>
  api
    .put(`/welfare/money-withdrwal/request/${welfareRequestId}/review`, null, {
      params: { reviewerId, reviewerRole, status, remark },
    })
    .then((r) => r.data);

const getAllWelfareRequests = (params) =>
  api.get('/welfare/money-withdrwal/requests', { params }).then((r) => r.data);

const getEngineerWelfareRequests = (engineerId) =>
  api.get(`/welfare/engineer/${engineerId}/money-withdrwal/request`).then((r) => r.data);

const getEngineerWelfareSummary = (engineerId) =>
  api.get(`/welfare/engineer/${engineerId}/summary`).then((r) => r.data);

const getAllEngineersWelfareSummary = () =>
  api.get('/welfare/all-engineer/summary').then((r) => r.data);

// ---------------------------------------------------------------------------
// UI: Withdrawal form (Engineer)
// ---------------------------------------------------------------------------
function WithdrawRequestForm({ onSubmitted }) {
  const [form, setForm] = useState({ amount: '', withdrawalReason: REASON_TYPES[0], remarks: '' });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.amount || Number(form.amount) <= 0) {
      setError('Enter a valid amount.');
      return;
    }
    setSubmitting(true);
    setError(null);
    try {
      await submitWelfareWithdrawal({ ...form, amount: Number(form.amount) });
      setForm({ amount: '', withdrawalReason: REASON_TYPES[0], remarks: '' });
      onSubmitted?.();
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={styles.form}>
      <h3>Request Welfare Withdrawal</h3>
      <label style={styles.label}>
        Amount
        <input type="number" name="amount" min="1" value={form.amount} onChange={handleChange} style={styles.input} required />
      </label>
      <label style={styles.label}>
        Reason
        <select name="withdrawalReason" value={form.withdrawalReason} onChange={handleChange} style={styles.input}>
          {REASON_TYPES.map((r) => <option key={r} value={r}>{r.replace(/_/g, ' ')}</option>)}
        </select>
      </label>
      <label style={styles.label}>
        Remarks
        <textarea name="remarks" value={form.remarks} onChange={handleChange} rows={2} style={styles.input} />
      </label>
      {error && <p style={styles.error}>{error}</p>}
      <button type="submit" disabled={submitting} style={styles.btnPrimary}>
        {submitting ? 'Submitting...' : 'Submit Request'}
      </button>
    </form>
  );
}

// ---------------------------------------------------------------------------
// UI: Review modal (Admin / SuperEngineer)
// ---------------------------------------------------------------------------
function WelfareReviewModal({ request, currentUser, onClose, onReviewed }) {
  const [status, setStatus] = useState('APPROVED');
  const [remark, setRemark] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      await reviewWelfareWithdrawal(request.id, currentUser.id, currentUser.role, status, remark);
      onReviewed?.();
      onClose();
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <h3>Review Welfare #{request.id}</h3>
        <p style={styles.subtitle}>{request.engineerName} · ₹{request.requestedAmount}</p>

        <label style={styles.label}>
          Decision
          <select value={status} onChange={(e) => setStatus(e.target.value)} style={styles.input}>
            <option value="APPROVED">APPROVED</option>
            <option value="REJECTED">REJECTED</option>
          </select>
        </label>
        <label style={styles.label}>
          Remark
          <textarea value={remark} onChange={(e) => setRemark(e.target.value)} rows={2} style={styles.input} />
        </label>

        {error && <p style={styles.error}>{error}</p>}

        <div style={styles.modalActions}>
          <button onClick={onClose} disabled={saving} style={styles.btnSecondary}>Cancel</button>
          <button onClick={handleSave} disabled={saving} style={styles.btnPrimary}>
            {saving ? 'Saving...' : 'Confirm'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// UI: Summary card
// ---------------------------------------------------------------------------
function SummaryCard({ summary }) {
  if (!summary) return null;
  return (
    <div style={styles.summaryCard}>
      <div><span style={styles.summaryLabel}>Balance</span><br /><span style={styles.summaryValue}>₹{summary.currentBalance}</span></div>
      <div><span style={styles.summaryLabel}>Total Credits</span><br /><span style={{ ...styles.summaryValue, color: '#1e8e5a' }}>₹{summary.totalCredits}</span></div>
      <div><span style={styles.summaryLabel}>Total Withdrawals</span><br /><span style={{ ...styles.summaryValue, color: '#c0392b' }}>₹{summary.totalWithdrawals}</span></div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Engineer view: summary + form + own history
// ---------------------------------------------------------------------------
function EngineerWelfareView({ currentUser }) {
  const [summary, setSummary] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [s, r] = await Promise.all([
        getEngineerWelfareSummary(currentUser.id),
        getEngineerWelfareRequests(currentUser.id),
      ]);
      setSummary(s);
      setItems(Array.isArray(r) ? r : []);
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  }, [currentUser.id]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <SummaryCard summary={summary} />
      <WithdrawRequestForm onSubmitted={load} />
      <h3>My Welfare Request History</h3>
      {loading && <p style={styles.muted}>Loading...</p>}
      {error && <p style={styles.error}>{error}</p>}
      {!loading && !error && !items.length && <p style={styles.muted}>No welfare requests found.</p>}
      {!loading && !error && items.length > 0 && (
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>ID</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Reason</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Requested</th>
            </tr>
          </thead>
          <tbody>
            {items.map((row) => (
              <tr key={row.id}>
                <td style={styles.td}>{row.id}</td>
                <td style={styles.td}>₹{row.requestedAmount}</td>
                <td style={styles.td}>{row.withdrawalReason?.replace(/_/g, ' ')}</td>
                <td style={styles.td}>{row.status}</td>
                <td style={styles.td}>{row.requestDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

// ---------------------------------------------------------------------------
// Reviewer view: requests tab + all-balances tab
// The "Engineer" filter is applied CLIENT-SIDE by name, against whatever
// page of data is currently loaded from the backend — it does not go to the
// API as a query param and does not affect pagination. If you need it to
// search the whole dataset (not just the current page), this needs to move
// back to a server-side param instead.
// ---------------------------------------------------------------------------
function ReviewerWelfareView({ currentUser }) {
  const [tab, setTab] = useState('requests');
  const [filters, setFilters] = useState({});
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [balances, setBalances] = useState([]);
  const [balancesLoading, setBalancesLoading] = useState(false);
  const [balancesSearchTerm, setBalancesSearchTerm] = useState('');
  const filterKey = JSON.stringify(filters);

  const loadRequests = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getAllWelfareRequests({ ...filters, page, size: 10 });
      setData(result);
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterKey, page]);

  const loadBalances = useCallback(async () => {
    setBalancesLoading(true);
    try {
      const result = await getAllEngineersWelfareSummary();
      setBalances(Array.isArray(result) ? result : []);
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setBalancesLoading(false);
    }
  }, []);

  useEffect(() => { if (tab === 'requests') loadRequests(); }, [tab, loadRequests]);
  useEffect(() => { if (tab === 'balances') loadBalances(); }, [tab, loadBalances]);
  useEffect(() => { setPage(0); }, [filterKey]);

  const trimmedRequestSearch = searchTerm.trim().toLowerCase();
  const requestItems = (data?.content || []).filter((row) =>
    trimmedRequestSearch ? row.engineerName?.toLowerCase().includes(trimmedRequestSearch) : true
  );

  const trimmedBalanceSearch = balancesSearchTerm.trim().toLowerCase();
  const balanceItems = balances.filter((row) =>
    trimmedBalanceSearch ? row.engineerName?.toLowerCase().includes(trimmedBalanceSearch) : true
  );

  return (
    <div>
      <div style={styles.tabRow}>
        <button style={tab === 'requests' ? styles.tabActive : styles.tab} onClick={() => setTab('requests')}>Requests</button>
        <button style={tab === 'balances' ? styles.tabActive : styles.tab} onClick={() => setTab('balances')}>All Balances</button>
      </div>

      {tab === 'requests' && (
        <>
          <div style={styles.filterRow}>
            <input
              type="text"
              placeholder="Search engineer name"
              style={styles.input}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <select style={styles.input} defaultValue=""
              onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value || undefined }))}>
              <option value="">All statuses</option>
              {WELFARE_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
            <input type="date" style={styles.input}
              onChange={(e) => setFilters((f) => ({ ...f, fromDate: e.target.value || undefined }))} />
            <input type="date" style={styles.input}
              onChange={(e) => setFilters((f) => ({ ...f, toDate: e.target.value || undefined }))} />
          </div>

          {loading && <p style={styles.muted}>Loading...</p>}
          {error && <p style={styles.error}>{error}</p>}
          {!loading && !error && !requestItems.length && <p style={styles.muted}>No welfare requests found.</p>}
          {!loading && !error && requestItems.length > 0 && (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>ID</th>
                  <th style={styles.th}>Engineer</th>
                  <th style={styles.th}>Amount</th>
                  <th style={styles.th}>Status</th>
                  <th style={styles.th}>Requested</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {requestItems.map((row) => (
                  <tr key={row.id}>
                    <td style={styles.td}>{row.id}</td>
                    <td style={styles.td}>{row.engineerName}</td>
                    <td style={styles.td}>₹{row.requestedAmount}</td>
                    <td style={styles.td}>{row.status}</td>
                    <td style={styles.td}>{row.requestDate}</td>
                    <td style={styles.td}>
                      {row.status === 'PENDING' && (
                        <button style={styles.linkBtn} onClick={() => setSelected(row)}>Review</button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {data && data.totalPages > 1 && (
            <div style={styles.pagination}>
              <button disabled={!data.hasPrevious} onClick={() => setPage((p) => p - 1)} style={styles.btnSecondary}>Prev</button>
              <span style={styles.muted}>Page {data.currentPage + 1} of {data.totalPages}</span>
              <button disabled={!data.hasNext} onClick={() => setPage((p) => p + 1)} style={styles.btnSecondary}>Next</button>
            </div>
          )}
        </>
      )}

      {tab === 'balances' && (
        <>
          <div style={styles.filterRow}>
            <input
              type="text"
              placeholder="Search engineer name"
              style={styles.input}
              value={balancesSearchTerm}
              onChange={(e) => setBalancesSearchTerm(e.target.value)}
            />
          </div>
          {balancesLoading && <p style={styles.muted}>Loading...</p>}
          {!balancesLoading && !balanceItems.length && <p style={styles.muted}>No engineers found.</p>}
          {!balancesLoading && balanceItems.length > 0 && (
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Engineer</th>
                  <th style={styles.th}>Balance</th>
                  <th style={styles.th}>Total Credits</th>
                  <th style={styles.th}>Total Withdrawals</th>
                </tr>
              </thead>
              <tbody>
                {balanceItems.map((row) => (
                  <tr key={row.engineerId}>
                    <td style={styles.td}>{row.engineerName}</td>
                    <td style={styles.td}>₹{row.currentBalance}</td>
                    <td style={styles.td}>₹{row.totalCredits}</td>
                    <td style={styles.td}>₹{row.totalWithdrawals}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}

      {selected && (
        <WelfareReviewModal
          request={selected}
          currentUser={currentUser}
          onClose={() => setSelected(null)}
          onReviewed={loadRequests}
        />
      )}
    </div>
  );
}

// ---------------------------------------------------------------------------
// Root export
// ---------------------------------------------------------------------------
export default function Welfare({ currentUser }) {
  if (!isAuthenticated(currentUser)) return <AuthRequired />;
  const isReviewer = isReviewerRole(currentUser?.role);
  return isReviewer ? <ReviewerWelfareView currentUser={currentUser} /> : <EngineerWelfareView currentUser={currentUser} />;
}
const styles = {
  form: { maxWidth: 420, display: 'flex', flexDirection: 'column', gap: 12, background: '#fff', padding: 20, borderRadius: 10, border: '1px solid #eee', marginBottom: 24 },
  label: { display: 'flex', flexDirection: 'column', gap: 4, fontSize: 13, fontWeight: 600, color: '#444' },
  input: { padding: '8px 10px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, fontWeight: 400 },
  btnPrimary: { padding: '8px 16px', border: 'none', borderRadius: 6, background: '#2d5bd7', color: '#fff', fontWeight: 600, cursor: 'pointer' },
  btnSecondary: { padding: '8px 16px', border: '1px solid #ddd', borderRadius: 6, background: '#fff', color: '#333', fontWeight: 600, cursor: 'pointer' },
  linkBtn: { background: 'none', border: 'none', color: '#2d5bd7', fontWeight: 600, cursor: 'pointer', padding: 0, fontSize: 13 },
  error: { color: '#c0392b', fontSize: 13 },
  muted: { color: '#777', fontSize: 13 },
  table: { width: '100%', borderCollapse: 'collapse', background: '#fff', borderRadius: 8, overflow: 'hidden' },
  th: { padding: '10px 12px', textAlign: 'left', borderBottom: '1px solid #f0f0f0', background: '#fafafa', fontSize: 13, fontWeight: 600, color: '#555' },
  td: { padding: '10px 12px', textAlign: 'left', borderBottom: '1px solid #f0f0f0', fontSize: 13 },
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: '#fff', width: 420, maxWidth: '92vw', borderRadius: 10, padding: 24, display: 'flex', flexDirection: 'column', gap: 12, maxHeight: '90vh', overflowY: 'auto' },
  subtitle: { color: '#777', fontSize: 13, margin: '-8px 0 4px' },
  modalActions: { display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 8 },
  tabRow: { display: 'flex', gap: 8, marginBottom: 16 },
  tab: { padding: '8px 16px', border: '1px solid #ddd', background: '#fff', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 600, color: '#555' },
  tabActive: { padding: '8px 16px', border: '1px solid #2d5bd7', background: '#2d5bd7', color: '#fff', borderRadius: 999, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
  filterRow: { display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' },
  pagination: { display: 'flex', alignItems: 'center', gap: 10, padding: '12px 4px' },
  summaryCard: { display: 'flex', gap: 24, background: '#fff', border: '1px solid #eee', borderRadius: 10, padding: '18px 24px', marginBottom: 20 },
  summaryLabel: { fontSize: 12, color: '#888' },
  summaryValue: { fontSize: 20, fontWeight: 700, color: '#222' },
};